'use strict';

angular.module('amexReconciliationApp')
  .component('transactionLinkIcon', {
    templateUrl: 'scripts/views/components/transaction-link-icon.html',
    bindings: {
      transaction: '<',
      transactionIndex: '<'
    },
    controller: function (TransactionService, SiteConfigModel, $state) {

      var self = this;
      
      self.isLinked = function() {
        return TransactionService.isLinked(self.transaction);
      };

      self.goToThirdPartyData = function() {
        var parameters = {
          transactionId: self.transaction.id,
          index: self.transactionIndex
        };

        if (SiteConfigModel.isBta()) {
          $state.go('transactions.overview.travel-data', parameters);
        } else if (SiteConfigModel.isPo()) {
          $state.go('transactions.overview.purchase-order-details', parameters);
        } else if (SiteConfigModel.isMeetings360() && self.isLinked()) {
          $state.go('transactions.overview.meeting360-details', parameters);
        } else {
          $state.go('transactions.overview.allocations', parameters);
        }
      };
      
      self.getLinkToolTip = function() {
        if (TransactionService.isLinked(self.transaction)) {
          if (SiteConfigModel.isBta()) {
            return 'transactions.titles.HasTravelDataLinked';
          } else if (SiteConfigModel.isPo()) {
            return 'transactions.titles.HasPODataLinked';
          } else if (SiteConfigModel.isMeetings360()) {
            return 'transactions.titles.HasMeetings360DataLinked';
          }
        } else {
          if (SiteConfigModel.isBta()) {
            return 'transactions.titles.NeedsTravelDataLinked';
          } else if (SiteConfigModel.isPo()) {
            return 'transactions.titles.NeedsPODataLinked';
          } else if (SiteConfigModel.isMeetings360()) {
            return 'transactions.titles.NeedsMeetings360DataLinked';
          }
        }
        return '';        
      };

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionLinkIcon.js
// module id = 489
// module chunks = 0